import "./style/index.scss"
import "bootstrap/dist/js/bootstrap.bundle.min"
import "./i18n"

import App from "./components/app"

export default App
